import { makeStyles, createStyles } from '@material-ui/core/styles';

import { variables } from '@styles';

/**
 * ImageContainer component styles
 * @returns {Function}
 */

export const useStyles = makeStyles((theme) =>
  createStyles({
    imageContainer: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      // backgroundColor: variables.color.primary.white,

      '&[data-ui-type=primary]': {
        // paddingTop: theme.spacing(1),
        // paddingBottom: theme.spacing(2),

        '& $title': {
          // padding: theme.spacing(2),
        },

        '& $imageSection': {
          marginBottom: theme.spacing(2),
        },

        '& $caption': {
          marginBottom: theme.spacing(1),
        },

        '& $widthSection': {
          display: 'flex',
        },

        '& $width': {
          marginRight: theme.spacing(2),
        },
      },
    },

    contentContainer: {
      background: variables.colorV2.panel.background.default,
      borderRadius: '2rem',
      flex: '0 1 auto',
      overflowY: 'hidden',
      marginBottom: '2rem',
      padding: '2rem 1.6rem',

      '& .MuiAccordion-root': {
        marginBottom: '2rem',
      },
    },

    panelHeader: {
      marginBottom: '0.4rem',
    },

    elementName: {
      fontWeight: 800,
    },

    settingsContainer: {
      height: '100%',
      overflowY: 'auto',
    },

    imageSrcWrapper: {
      display: 'flex',
    },

    imageSrc: {
      width: '100%',
      '& input': {
        height: '3rem',
      },
    },

    selectBtn: {
      marginLeft: theme.spacing(1),
      width: '6.5rem',
      height: '3.2rem',
    },

    closeBtn: {
      height: '3.2rem',
      marginRight: '0.8rem',
      width: '6.5rem',
    },

    label: {
      marginTop: '.5rem',
      // marginBottom: '5px',
    },

    imageSection: {},
    widthSection: {
      display: 'flex',
      '& input': {
        height: '3rem',
      },
    },
    bottomInput: {
      paddingTop: '1.6rem',
    },

    width: {
      marginRight: theme.spacing(2),
    },
    titleWrapper: {
      flex: '0 0 auto',
      padding: '0 1.6rem 2rem 0',
    },
    title: {
      alignItems: 'center',
      color: `${variables.colorV2.text.header}`,
      display: 'flex',
      fontSize: '2rem',
      fontWeight: 400,
      lineHeight: '2.5rem',
      justifyContent: 'space-between',
      // paddingBottom: '1rem',
    },

    content: {
      background: variables.colorV2.panel.background.default,
      borderRadius: '2rem',
      padding: '2rem 1.6rem',
      // flexDirection: 'column',
    },

    DVcontent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      marginBottom: '15px',
    },

    cancelBtn: {
      marginRight: theme.spacing(1),

      '&.hovered': {
        color: variables.color.primary.mainPurple,
        border: `0.2rem solid ${variables.color.primary.lightPurple}`,
      },
      '&.hovered svg path': {
        stroke: variables.color.primary.mainPurple,
      },
    },

    renameBar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      padding: '7px 10px 10px 16px',
    },

    renameBarButtons: {
      display: 'flex',
    },

    saveCloseContainer: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'flex-start',
    },

    caption: {},

    inputContainer: {
      width: '100%',
    },

    linkTitleInput: {
      '&[disabled]': {
        '& input': {
          color: variables.colorV2.text.disabled,
        },
      },
    },

    editModeContainer: {
      padding: '2rem 1.6rem 2rem 1.6rem',
    },

    maintainProportionsContainer: {
      display: 'flex',
      margin: '1.6rem 0 1.6rem 0',
    },

    checkbox: {
      padding: '0 0 0 0',
    },

    buttonContainer: {
      display: 'flex',
      justifyContent: 'flex-start',
      // minWidth: '60rem',
      // width: '60rem',
    },

    save: {
      // marginLeft: 'auto',
      '&:disabled': {
        // backgroundColor: variables.color.primary.backgroundLighterGray,
        // border: `0.1rem solid ${variables.color.primary.lightGrayDarker}`,
        // color: variables.color.primary.lightGrayDarker,
      },
    },

    close: {
      '&&': {
        borderRadius: '3.2rem',
        fontWeight: 500,
        marginRight: '.8rem',
        // border: `1px solid ${variables.colorV2.button.contained.secondary.border.default}`,
        // color: variables.colorV2.button.contained.secondary.text.default,

        '&:hover': {
          // backgroundColor: variables.colorV2.button.contained.secondary.background.hover,
          // border: `1px solid ${variables.colorV2.button.contained.secondary.border.hover}`,
          // color: variables.colorV2.button.contained.secondary.text.hover,
        },
      },
    },
  }),
);
